<template>
  <Modal :open="open" @close="closeModal">
    <div class="text-center mb-6">
      <h2 class="text-2xl font-bold text-gray-900">Versement des primes – comment ça fonctionne ?</h2>
    </div>

    <div class="space-y-4 text-gray-700">
      <div class="flex items-start space-x-3">
        <span class="text-2xl">🎁</span>
        <p class="text-base">
          Vos primes sont versées directement par Estaly, sous forme de
          <span class="font-bold">cartes cadeaux.</span>
        </p>
      </div>

      <div class="flex items-start space-x-3">
        <span class="text-2xl">📅</span>
        <p class="text-base">
          Envoi de vos cartes cadeaux
          <span class="font-bold">en magasin le 1er du mois suivant vos ventes,</span>
          réception prévue entre
          <span class="font-bold">le 1 et le 15 du mois.</span>
          Pour rappel, elles sont activées 48 h après livraison.
        </p>
      </div>

      <div class="flex items-start space-x-3">
        <span class="text-2xl">🚀</span>
        <p class="text-base">Continuez à vendre pour maximiser votre carte cadeau du mois prochain !</p>
      </div>
    </div>
    <div class="mt-8 text-center flex justify-end">
      <SecondaryButton @click="closeModal">J'ai compris 😊</SecondaryButton>
    </div>
  </Modal>
</template>

<script>
import { Modal, SecondaryButton } from "@estaly/ui";

export default {
  components: {
    Modal,
    SecondaryButton,
  },
  props: {
    open: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["close"],
  methods: {
    closeModal() {
      this.$emit("close");
    },
  },
};
</script>
